import React from 'react';
import dynamic from 'next/dynamic';
import { getServerHostDomain } from '@utils/serverConfig';
import axios from 'axios';
/**
 * style
 */
import { CenterDiv, GlobalStyle } from '@utils/styles';
/**
 * interface
 */
import { ICashlessCardDetails } from '@interfaces/partnership/cashlesscard';

const CashlessCard = dynamic(
    () => import('@components/partnership/cashlesscard'),
    {
        ssr: true,
    }
);

const ErrorScreen = dynamic(() => import('@widgets/errorScreen'), {
    ssr: true,
});

function CashlessCardInstruction({
    name,
    uhid,
    policyNumber,
    relationship,
    policyid,
    errorMessage,
}: ICashlessCardDetails) {
    if (errorMessage) {
        return (
            <div>
                <GlobalStyle />
                <CenterDiv styles={`margin-top: 20px`}>
                    <ErrorScreen errorMessage={errorMessage} />
                </CenterDiv>
            </div>
        );
    }
    return (
        <div>
            <CashlessCard
                name={name}
                uhid={uhid}
                policyNumber={policyNumber}
                relationship={relationship}
                policyid={policyid}
                errorMessage={errorMessage}
            />
        </div>
    );
}

export async function getServerSideProps(ctx) {
    const { uhid, policyid } = ctx.query;

    if (uhid && policyid) {
        const url = `${getServerHostDomain(
            ctx.req.headers.host
        )}/partnerships/fetch/cashlesscard?policy_ekey=${policyid}&uhid=${uhid}`;

        try {
            const response = await axios.get(url);
            if (response.status === 200 && response.data.policy_number) {
                const { name, policy_number, relationship } = response.data;
                return {
                    props: {
                        name,
                        uhid,
                        policyNumber: policy_number,
                        relationship,
                        policyid,
                        errorMessage: '',
                    },
                };
            }
            return {
                props: {
                    errorMessage:
                        'Oops. something went wrong, please try again.',
                },
            };
        } catch (e) {
            return {
                props: {
                    errorMessage:
                        'Oops. something went wrong, please try again.',
                },
            };
        }
    } else {
        return {
            props: {
                errorMessage: ' Oops. something went wrong, please try again.',
            },
        };
    }
}

export default CashlessCardInstruction;
